<script lang="ts">
	import { Select } from "flowbite-svelte-v1";
	import Label from "#lib/components/Label.svelte";
	import ColorInputV2 from "#lib/components/flow/editor/appearance/ColorInputV2.svelte";
	import { FONT_WEIGHTS, HORIZONTAL_ALIGNMENTS } from "#lib/components/flow/editor/appearance/constants.js";
	import { camelCase } from "#lib/string.js";
	import type { JsonValue } from "@bufbuild/protobuf";

	interface Props {
		prefix?: string;
		defaults?: Record<string, JsonValue>;
		values: Record<string, JsonValue>;
		onInput?: (key: string, value: JsonValue) => void;
		onChange?: (key: string, value: JsonValue) => void;
		onReset?: (key: string) => void;
	}

	let { prefix = "", defaults = {}, values, onInput, onChange, onReset }: Props = $props();

	const alignmentId = $derived(camelCase(prefix + "TextAlignment"));
	const fontWeightId = $derived(camelCase(prefix + "FontWeight"));
	const textColorId = $derived(camelCase(prefix + "TextColor"));
	const backgroundColorId = $derived(camelCase(prefix + "BackgroundColor"));

	function handleChangeAppearance(e: Event, key: string) {
		const value = (e.target as HTMLSelectElement).value;
		onChange?.(key, value);
	}

	function handleColorInput(key: string, value: string) {
		onInput?.(key, value);
	}

	function resetToPageStyle(key: string) {
		onReset?.(key);
	}
</script>

<div class="flex flex-col justify-between gap-2 border-l-[5px] border-l-gray-300 pl-6">
	<div class="flex flex-row gap-2">
		<div class="flex min-w-0 flex-1 flex-col gap-1">
			<Label for={alignmentId} class="font-medium">Text alignment</Label>
			<Select classes={{ select: "truncate" }} items={HORIZONTAL_ALIGNMENTS} value={values[alignmentId] ?? defaults[alignmentId]} aria-labelledby={alignmentId} onchange={e => handleChangeAppearance(e, alignmentId)} />
		</div>
		<div class="flex min-w-0 flex-1 flex-col gap-1">
			<Label for={fontWeightId} class="font-medium">Font weight</Label>
			<Select classes={{ select: "truncate" }} items={FONT_WEIGHTS} value={values[fontWeightId] ?? defaults[fontWeightId]} aria-labelledby={fontWeightId} onchange={e => handleChangeAppearance(e, fontWeightId)} />
		</div>
	</div>
	<div class="flex flex-row gap-2">
		<div class="flex min-w-0 flex-1 flex-col gap-1">
			<Label for={textColorId} class="font-medium">Text color</Label>
			<ColorInputV2 id={textColorId} resetColor={defaults[textColorId] as string} display="inline" value={(values[textColorId] as string) ?? defaults[textColorId]} onReset={() => resetToPageStyle(textColorId)} oninput={value => handleColorInput(textColorId, value)} onchange={value => onChange?.(textColorId, value)} />
		</div>
		<div class="flex min-w-0 flex-1 flex-col gap-1">
			<Label for={backgroundColorId} class="font-medium">Background color</Label>
			<ColorInputV2 id={backgroundColorId} allowTransparent resetColor={defaults[backgroundColorId] as string} display="inline" value={(values[backgroundColorId] as string) ?? defaults[backgroundColorId]} onReset={() => resetToPageStyle(backgroundColorId)} oninput={value => handleColorInput(backgroundColorId, value)} onchange={value => onChange?.(backgroundColorId, value)} />
		</div>
	</div>
</div>
